// extracted by mini-css-extract-plugin
export default {"license":"L_cZ","info":"L_Q","security":"L_cD","socialIcons":"L_cL","gamblingText":"L_c0","templateOne":"L_c1","templateTwo":"L_cX","templateThree":"L_c2","logo":"L_F"};